export const loginState = {
    userName: "",
    password: "",
    isLoading: false,
    Message: "",
    loginStatus: 0,
    authTokenId: "",
    userId: 0,
    statusCode:'',
    errorCode:'',
    errorMessage:''
}

